import { render } from "./SinElementos.vue?vue&type=template&id=297dc6d7&scoped=true"
import script from "./SinElementos.vue?vue&type=script&lang=js"
export * from "./SinElementos.vue?vue&type=script&lang=js"

import "./SinElementos.vue?vue&type=style&index=0&id=297dc6d7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297dc6d7"]])

export default __exports__